import { render } from "./ActionButton.vue?vue&type=template&id=fcfbae5a"
import script from "./ActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ActionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcfbae5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcfbae5a', __exports__)) {
    api.reload('fcfbae5a', __exports__)
  }
  
  module.hot.accept("./ActionButton.vue?vue&type=template&id=fcfbae5a", () => {
    api.rerender('fcfbae5a', render)
  })

}


export default __exports__